import { useState } from 'react';
import { Link } from 'react-router-dom';
import CartButton from '../../components/feature/CartButton';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [email, setEmail] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // 스크롤 이벤트 처리
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsScrolled(window.scrollY > 50);
    });
  }

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // 뉴스레터 구독 처리
    console.log('Newsletter subscription:', email);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* 네비게이션 */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 sm:py-6 flex items-center justify-between">
          <div className="flex items-center gap-8 lg:gap-12">
            <img 
              src="https://static.readdy.ai/image/f77122aa20e12351d50b895437d7646f/26f7e4287336b6a14c4caa48b3ce1ec3.png" 
              alt="초이담 참새한과" 
              className="h-12 w-auto cursor-pointer transition-all duration-300 hover:scale-110 hover:opacity-80" 
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
            <div className="hidden lg:flex items-center gap-8">
              <a href="#home" onClick={(e) => { e.preventDefault(); document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' }); }} className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-amber-700' : 'text-white hover:text-amber-200'}`}>홈</a>
              <a href="#about" onClick={(e) => { e.preventDefault(); document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' }); }} className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-amber-700' : 'text-white hover:text-amber-200'}`}>브랜드 소개</a>
              <a href="#custom-gifts" onClick={(e) => { e.preventDefault(); document.getElementById('custom-gifts')?.scrollIntoView({ behavior: 'smooth' }); }} className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-amber-700' : 'text-white hover:text-amber-200'}`}>맞춤 선물</a>
              <a href="#menu" onClick={(e) => { e.preventDefault(); document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' }); }} className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-amber-700' : 'text-white hover:text-amber-200'}`}>메뉴</a>
              <a href="#testimonials" onClick={(e) => { e.preventDefault(); document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' }); }} className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-amber-700' : 'text-white hover:text-amber-200'}`}>고객 후기</a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }} className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-amber-700' : 'text-white hover:text-amber-200'}`}>문의</a>
            </div>
          </div>
          <div className="flex items-center gap-2 sm:gap-3">
            <CartButton isScrolled={isScrolled} />
            <button className={`hidden sm:block px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${isScrolled ? 'bg-gray-900 text-white hover:bg-gray-800' : 'bg-white text-gray-900 hover:bg-gray-100'}`}>
              주문하기
            </button>
            {/* 모바일 메뉴 버튼 */}
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-full transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
        
        {/* 모바일 메뉴 */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white shadow-lg">
            <div className="px-4 py-6 space-y-4">
              <a href="#home" onClick={(e) => { e.preventDefault(); setIsMobileMenuOpen(false); document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-gray-900 font-medium py-2 cursor-pointer">홈</a>
              <a href="#about" onClick={(e) => { e.preventDefault(); setIsMobileMenuOpen(false); document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-gray-900 font-medium py-2 cursor-pointer">브랜드 소개</a>
              <a href="#custom-gifts" onClick={(e) => { e.preventDefault(); setIsMobileMenuOpen(false); document.getElementById('custom-gifts')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-gray-900 font-medium py-2 cursor-pointer">맞춤 선물</a>
              <a href="#menu" onClick={(e) => { e.preventDefault(); setIsMobileMenuOpen(false); document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-gray-900 font-medium py-2 cursor-pointer">메뉴</a>
              <a href="#testimonials" onClick={(e) => { e.preventDefault(); setIsMobileMenuOpen(false); document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-gray-900 font-medium py-2 cursor-pointer">고객 후기</a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); setIsMobileMenuOpen(false); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-gray-900 font-medium py-2 cursor-pointer">문의</a>
              <button className="w-full px-6 py-3 bg-gray-900 text-white rounded-full font-medium whitespace-nowrap cursor-pointer">
                주문하기
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* 히어로 섹션 */}
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <img 
          src="https://static.readdy.ai/image/f77122aa20e12351d50b895437d7646f/8778fcd8b8e60918cf8091dab695237e.png" 
          alt="한과 배경" 
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        
        <div className="relative z-10 text-center px-4 sm:px-8 max-w-4xl mx-auto pt-20">
          <div className="inline-flex items-center gap-2 bg-amber-100/90 backdrop-blur-sm px-3 sm:px-5 py-1.5 sm:py-2 rounded-full mb-6 sm:mb-8">
            <i className="ri-sparkling-2-fill text-amber-700 text-sm sm:text-base"></i>
            <span className="text-xs sm:text-sm font-medium text-amber-900">수제 한과 전문</span>
            <span className="ml-1 sm:ml-2 bg-amber-700 text-white text-xs px-2 sm:px-3 py-0.5 sm:py-1 rounded-full whitespace-nowrap">주문 제작</span>
          </div>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-3 sm:mb-4 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
            정성으로 만든<br />초이담 참새한과
          </h1>
          
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90 mb-8 sm:mb-12 leading-relaxed max-w-2xl mx-auto px-4">
            주문 제작 방식으로 더 신선하게,<br />좋은 재료를 아끼지 않습니다
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
            <Link to="/custom-order" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="w-full sm:w-auto">
              <button className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base">
                맞춤 선물 주문하기
              </button>
            </Link>
            <a href="#menu" className="w-full sm:w-auto">
              <button className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white text-amber-900 rounded-full font-medium border-2 border-amber-900 hover:bg-amber-50 transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base">
                메뉴 둘러보기
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* 브랜드 소개 섹션 */}
      <section id="about" className="relative py-16 sm:py-24 lg:py-32 overflow-hidden" style={{ background: 'linear-gradient(180deg, #8B6F47 0%, #5D4E37 100%)' }}>
        <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
          <div className="mb-4 sm:mb-6">
            <span className="inline-block bg-pink-200/30 backdrop-blur-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded text-xs sm:text-sm text-pink-100 font-medium">/ 우리의 이야기</span>
          </div>
          
          <div className="mb-12 sm:mb-16 lg:mb-20">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              전통의 맛을 지키며<br />현대의 감각을 담다
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-amber-100/80 leading-relaxed max-w-2xl" style={{ lineHeight: '1.8' }}>
              초이담 참새한과는 1987년부터 이어온 한과 장인의 손길로
              우리 고유의 맛과 멋을 지켜왔습니다.
              <span className="hidden sm:inline"><br /></span>
              <span className="sm:hidden"> </span>
              주문 제작 방식으로 신선함을 더하고, 엄선된 국산 재료만을 사용하여
              정성스럽게 만든 한과를 선보입니다.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div className="bg-amber-50 rounded-2xl overflow-hidden aspect-square">
              <img 
                src="https://public.readdy.ai/ai/img_res/40126d44fb349ed47179d19348caa9e7.jpg" 
                alt="한과 제작 과정" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="text-center md:text-left">
              <div className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-2 sm:mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>1987</div>
              <p className="text-lg sm:text-xl text-amber-100/90 mb-6 sm:mb-8 leading-relaxed">
                년부터 이어온<br />한과 장인의 손길
              </p>
              <Link to="/about">
                <button className="px-6 sm:px-8 py-2.5 sm:py-3 bg-white text-gray-900 rounded-full font-medium hover:bg-amber-50 transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base">
                  자세히 보기
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 맞춤 선물 CTA 섹션 */}
      <section id="custom-gifts" className="relative min-h-[70vh] sm:min-h-screen flex items-center justify-center overflow-hidden py-16 sm:py-0">
        <img 
          src="https://readdy.ai/api/search-image?query=Elegant%20Korean%20traditional%20gift%20set%20wrapped%20in%20beautiful%20bojagi%20fabric%2C%20premium%20hangwa%20confectionery%20gift%20box%2C%20luxurious%20presentation%20on%20wooden%20table%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20high-end%20product%20photography%20style%2C%20sophisticated%20composition&width=1920&height=1080&seq=gift-cta-001&orientation=landscape" 
          alt="맞춤 선물" 
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/40 sm:bg-black/30"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 w-full">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-8">
            <div className="mb-8 md:mb-0">
              <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6 sm:mb-8" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                명절 선물,<br />마음을 담아
              </h2>
              <Link to="/custom-order" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                <button className="group flex items-center gap-3 sm:gap-4 px-6 sm:px-8 py-3 sm:py-4 bg-white rounded-full hover:bg-amber-50 transition-all whitespace-nowrap cursor-pointer">
                  <span className="text-gray-900 font-medium text-sm sm:text-base">맞춤 선물 주문하기</span>
                  <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-900 rounded-full flex items-center justify-center group-hover:bg-amber-900 transition-colors">
                    <i className="ri-arrow-right-line text-white text-base sm:text-lg"></i>
                  </div>
                </button>
              </Link>
            </div>
            
            <div className="text-left md:text-right">
              <p className="text-base sm:text-lg md:text-xl text-white leading-relaxed">
                주문 제작으로 특별함을 더하는<br />초이담만의 맞춤 선물 서비스
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 메뉴 섹션 */}
      <section id="menu" className="py-16 sm:py-24 lg:py-32 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="mb-10 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-2 sm:mb-4" style={{ fontFamily: "'Noto Serif KR', serif" }}>우리의 한과</h2>
            <p className="text-gray-600 text-sm sm:text-base">정성으로 만든 수제 한과 메뉴</p>
          </div>
          
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-10" data-product-shop>
            {/* 약과 카드 */}
            <Link to="/product/yakgwa" className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer">
              <div className="bg-amber-50 aspect-square flex items-center justify-center p-4 sm:p-8">
                <img 
                  src="https://readdy.ai/api/search-image?query=Traditional%20Korean%20yakgwa%20honey%20cookies%20arranged%20beautifully%20on%20white%20ceramic%20plate%2C%20golden%20brown%20color%2C%20glossy%20honey%20coating%2C%20simple%20cream%20background%2C%20top%20view%2C%20professional%20food%20photography%2C%20appetizing%20presentation%2C%20artisanal%20quality&width=600&height=600&seq=menu-yakgwa-001&orientation=squarish" 
                  alt="약과" 
                  className="w-full h-full object-cover object-top rounded-xl sm:rounded-2xl"
                />
              </div>
              <div className="p-4 sm:p-8 text-center">
                <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2" style={{ fontFamily: "'Noto Serif KR', serif" }}>약과</h3>
                <p className="text-xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-6">15,000원<span className="text-sm sm:text-base font-normal">부터</span></p>
                <div className="w-full sm:w-4/5 mx-auto block px-3 sm:px-6 py-2 sm:py-3 bg-gray-900 text-white rounded-full font-medium text-xs sm:text-base whitespace-nowrap mb-2 sm:mb-3">
                  인기 메뉴
                </div>
                <p className="text-xs text-gray-400 hidden sm:block">주문 제작 상품</p>
              </div>
            </Link>

            {/* 유과 카드 */}
            <Link to="/product/yugwa" className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer">
              <div className="bg-pink-50 aspect-square flex items-center justify-center p-4 sm:p-8">
                <img 
                  src="https://readdy.ai/api/search-image?query=Traditional%20Korean%20yugwa%20rice%20puffs%20in%20pastel%20colors%2C%20colorful%20assorted%20pieces%20on%20white%20plate%2C%20pink%20yellow%20green%20colors%2C%20simple%20cream%20background%2C%20top%20view%20angle%2C%20professional%20food%20photography%2C%20delicate%20presentation%2C%20handmade%20quality&width=600&height=600&seq=menu-yugwa-001&orientation=squarish" 
                  alt="유과" 
                  className="w-full h-full object-cover object-top rounded-xl sm:rounded-2xl"
                />
              </div>
              <div className="p-4 sm:p-8 text-center">
                <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2" style={{ fontFamily: "'Noto Serif KR', serif" }}>유과</h3>
                <p className="text-xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-6">18,000원<span className="text-sm sm:text-base font-normal">부터</span></p>
                <div className="w-full sm:w-4/5 mx-auto block px-3 sm:px-6 py-2 sm:py-3 bg-white text-gray-900 border-2 border-gray-900 rounded-full font-medium text-xs sm:text-base whitespace-nowrap mb-2 sm:mb-3">
                  자세히 보기
                </div>
                <p className="text-xs text-gray-400 hidden sm:block">주문 제작 상품</p>
              </div>
            </Link>

            {/* 한과 선물 세트 카드 */}
            <Link to="/product/gift-set" className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer">
              <div className="bg-green-50 aspect-square flex items-center justify-center p-4 sm:p-8">
                <img 
                  src="https://readdy.ai/api/search-image?query=Premium%20Korean%20traditional%20confectionery%20gift%20set%20in%20elegant%20box%2C%20assorted%20hangwa%20varieties%20beautifully%20arranged%2C%20luxurious%20presentation%2C%20simple%20cream%20background%2C%20top%20view%20perspective%2C%20professional%20product%20photography%2C%20gift-worthy%20display&width=600&height=600&seq=menu-giftset-001&orientation=squarish" 
                  alt="한과 선물 세트" 
                  className="w-full h-full object-cover object-top rounded-xl sm:rounded-2xl"
                />
              </div>
              <div className="p-4 sm:p-8 text-center">
                <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2" style={{ fontFamily: "'Noto Serif KR', serif" }}>선물 세트</h3>
                <p className="text-xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-6">35,000원<span className="text-sm sm:text-base font-normal">부터</span></p>
                <div className="w-full sm:w-4/5 mx-auto block px-3 sm:px-6 py-2 sm:py-3 bg-white text-gray-900 border-2 border-gray-900 rounded-full font-medium text-xs sm:text-base whitespace-nowrap mb-2 sm:mb-3">
                  자세히 보기
                </div>
                <p className="text-xs text-gray-400 hidden sm:block">주문 제작 상품</p>
              </div>
            </Link>

            {/* 강정 카드 */}
            <Link to="/product/gangjeong" className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer">
              <div className="bg-orange-50 aspect-square flex items-center justify-center p-4 sm:p-8">
                <img 
                  src="https://readdy.ai/api/search-image?query=Traditional%20Korean%20gangjeong%20crispy%20rice%20puffs%20coated%20with%20honey%20and%20sesame%20seeds%2C%20golden%20brown%20color%20with%20visible%20sesame%20coating%2C%20beautifully%20arranged%20on%20white%20ceramic%20plate%2C%20simple%20cream%20background%2C%20top%20view%2C%20professional%20food%20photography%2C%20appetizing%20crunchy%20texture&width=600&height=600&seq=menu-gangjeong-001&orientation=squarish" 
                  alt="강정" 
                  className="w-full h-full object-cover object-top rounded-xl sm:rounded-2xl"
                />
              </div>
              <div className="p-4 sm:p-8 text-center">
                <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2" style={{ fontFamily: "'Noto Serif KR', serif" }}>강정</h3>
                <p className="text-xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-6">12,000원<span className="text-sm sm:text-base font-normal">부터</span></p>
                <div className="w-full sm:w-4/5 mx-auto block px-3 sm:px-6 py-2 sm:py-3 bg-white text-gray-900 border-2 border-gray-900 rounded-full font-medium text-xs sm:text-base whitespace-nowrap mb-2 sm:mb-3">
                  자세히 보기
                </div>
                <p className="text-xs text-gray-400 hidden sm:block">주문 제작 상품</p>
              </div>
            </Link>

            {/* 다식 카드 */}
            <Link to="/product/dasik" className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer">
              <div className="bg-emerald-50 aspect-square flex items-center justify-center p-4 sm:p-8">
                <img 
                  src="https://readdy.ai/api/search-image?query=Traditional%20Korean%20dasik%20pressed%20tea%20cookies%20with%20intricate%20floral%20patterns%2C%20assorted%20colors%20including%20matcha%20green%20sesame%20brown%20and%20pine%20nut%20yellow%2C%20beautifully%20arranged%20on%20white%20ceramic%20plate%2C%20simple%20cream%20background%2C%20top%20view%2C%20professional%20food%20photography%2C%20delicate%20traditional%20confectionery&width=600&height=600&seq=menu-dasik-001&orientation=squarish" 
                  alt="다식" 
                  className="w-full h-full object-cover object-top rounded-xl sm:rounded-2xl"
                />
              </div>
              <div className="p-4 sm:p-8 text-center">
                <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2" style={{ fontFamily: "'Noto Serif KR', serif" }}>다식</h3>
                <p className="text-xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-6">16,000원<span className="text-sm sm:text-base font-normal">부터</span></p>
                <div className="w-full sm:w-4/5 mx-auto block px-3 sm:px-6 py-2 sm:py-3 bg-white text-gray-900 border-2 border-gray-900 rounded-full font-medium text-xs sm:text-base whitespace-nowrap mb-2 sm:mb-3">
                  자세히 보기
                </div>
                <p className="text-xs text-gray-400 hidden sm:block">주문 제작 상품</p>
              </div>
            </Link>

            {/* 정과 카드 */}
            <Link to="/product/jeonggwa" className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer">
              <div className="bg-rose-50 aspect-square flex items-center justify-center p-4 sm:p-8">
                <img 
                  src="https://readdy.ai/api/search-image?query=Traditional%20Korean%20jeonggwa%20candied%20fruits%20and%20roots%2C%20translucent%20honey%20glazed%20ginger%20slices%20lotus%20root%20pieces%2C%20jewel-like%20appearance%20with%20golden%20amber%20color%2C%20beautifully%20arranged%20on%20white%20ceramic%20plate%2C%20simple%20cream%20background%2C%20top%20view%2C%20professional%20food%20photography%2C%20luxurious%20traditional%20confectionery&width=600&height=600&seq=menu-jeonggwa-001&orientation=squarish" 
                  alt="정과" 
                  className="w-full h-full object-cover object-top rounded-xl sm:rounded-2xl"
                />
              </div>
              <div className="p-4 sm:p-8 text-center">
                <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2" style={{ fontFamily: "'Noto Serif KR', serif" }}>정과</h3>
                <p className="text-xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-6">20,000원<span className="text-sm sm:text-base font-normal">부터</span></p>
                <div className="w-full sm:w-4/5 mx-auto block px-3 sm:px-6 py-2 sm:py-3 bg-white text-gray-900 border-2 border-gray-900 rounded-full font-medium text-xs sm:text-base whitespace-nowrap mb-2 sm:mb-3">
                  자세히 보기
                </div>
                <p className="text-xs text-gray-400 hidden sm:block">주문 제작 상품</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* 고객 후기 섹션 */}
      <section id="testimonials" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-amber-50/50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="mb-10 sm:mb-16">
            <span className="inline-block bg-amber-100 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm text-amber-900 font-medium mb-3 sm:mb-4">고객 후기</span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              고객님들의<br />소중한 이야기
            </h2>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {/* 후기 1 */}
            <div className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-full flex items-center justify-center">
                  <span className="text-amber-900 font-bold text-sm sm:text-base">김</span>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm sm:text-base">김민지</div>
                  <div className="text-xs sm:text-sm text-gray-500">@초이담고객</div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base" style={{ lineHeight: '1.6' }}>
                "명절 선물로 보냈는데 너무 좋아하셨어요. 포장도 정성스럽고 맛도 일품입니다. 다음에도 꼭 주문할게요!"
              </p>
            </div>

            {/* 후기 2 */}
            <div className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-pink-100 rounded-full flex items-center justify-center">
                  <span className="text-pink-900 font-bold text-sm sm:text-base">이</span>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm sm:text-base">이서준</div>
                  <div className="text-xs sm:text-sm text-gray-500">@초이담고객</div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base" style={{ lineHeight: '1.6' }}>
                "주문 제작이라 그런지 정말 신선하고 맛있어요. 시중에서 파는 한과와는 차원이 다릅니다. 강력 추천합니다!"
              </p>
            </div>

            {/* 후기 3 */}
            <div className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-900 font-bold text-sm sm:text-base">박</span>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm sm:text-base">박지현</div>
                  <div className="text-xs sm:text-sm text-gray-500">@초이담고객</div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base" style={{ lineHeight: '1.6' }}>
                "어머니께서 너무 좋아하셔서 매번 주문하고 있어요. 전통의 맛을 제대로 느낄 수 있는 곳입니다."
              </p>
            </div>

            {/* 후기 4 - 모바일에서 숨김 */}
            <div className="hidden sm:block bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-900 font-bold text-sm sm:text-base">최</span>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm sm:text-base">최수현</div>
                  <div className="text-xs sm:text-sm text-gray-500">@초이담고객</div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base" style={{ lineHeight: '1.6' }}>
                "회사 선물로 주문했는데 반응이 정말 좋았습니다. 고급스러운 포장과 맛있는 한과, 완벽했어요!"
              </p>
            </div>

            {/* 후기 5 - 모바일에서 숨김 */}
            <div className="hidden lg:block bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-purple-100 rounded-full flex items-center justify-center">
                  <span className="text-purple-900 font-bold text-sm sm:text-base">정</span>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm sm:text-base">정예린</div>
                  <div className="text-xs sm:text-sm text-gray-500">@초이담고객</div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base" style={{ lineHeight: '1.6' }}>
                "약과가 정말 맛있어요. 달지 않고 고소해서 아이들도 좋아합니다. 건강한 간식으로 최고예요!"
              </p>
            </div>

            {/* 후기 6 - 모바일에서 숨김 */}
            <div className="hidden lg:block bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-full flex items-center justify-center">
                  <span className="text-orange-900 font-bold text-sm sm:text-base">강</span>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm sm:text-base">강태우</div>
                  <div className="text-xs sm:text-sm text-gray-500">@초이담고객</div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base" style={{ lineHeight: '1.6' }}>
                "유과의 바삭함이 일품입니다. 신선하게 만들어서 그런지 식감이 정말 좋아요. 재주문 필수!"
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 특징 그리드 섹션 */}
      <section className="py-16 sm:py-24 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="flex flex-col md:flex-row justify-between items-start mb-10 sm:mb-16 lg:mb-20 gap-4 sm:gap-6">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              초이담만의<br />특별함
            </h2>
            <p className="text-gray-600 max-w-md leading-relaxed text-sm sm:text-base">
              주문 제작 방식과 엄선된 재료로<br />더 신선하고 맛있는 한과를 만듭니다
            </p>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {/* 주문 제작 카드 */}
            <div className="bg-gray-50 rounded-xl sm:rounded-2xl overflow-hidden">
              <div className="aspect-video">
                <img 
                  src="https://readdy.ai/api/search-image?query=Korean%20confectionery%20artisan%20hands%20carefully%20crafting%20traditional%20hangwa%2C%20detailed%20close-up%20of%20making%20process%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20professional%20craftsmanship%20photography%2C%20traditional%20food%20preparation%2C%20artisanal%20quality&width=800&height=600&seq=feature-craft-001&orientation=landscape" 
                  alt="주문 제작" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">주문 제작</h3>
                <p className="text-gray-600 text-sm sm:text-base">신선함을 위한 당일 제조 시스템</p>
              </div>
            </div>

            {/* 엄선된 재료 카드 */}
            <div className="bg-gray-50 rounded-xl sm:rounded-2xl overflow-hidden">
              <div className="p-5 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-8 text-center">엄선된 재료</h3>
              </div>
              <div className="aspect-video">
                <img 
                  src="https://readdy.ai/api/search-image?query=Premium%20Korean%20ingredients%20for%20traditional%20confectionery%2C%20rice%20flour%20honey%20sesame%20seeds%20arranged%20beautifully%2C%20natural%20organic%20materials%2C%20simple%20cream%20background%2C%20top%20view%2C%20professional%20food%20photography%2C%20high%20quality%20ingredients%20display&width=800&height=600&seq=feature-ingredients-001&orientation=landscape" 
                  alt="엄선된 재료" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* 정성스런 포장 카드 */}
            <div className="bg-gray-50 rounded-xl sm:rounded-2xl overflow-hidden sm:col-span-2 lg:col-span-1">
              <div className="p-5 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-8 text-center">정성스런 포장</h3>
              </div>
              <div className="aspect-video">
                <img 
                  src="https://readdy.ai/api/search-image?query=Elegant%20Korean%20traditional%20gift%20packaging%20with%20bojagi%20fabric%20wrapping%2C%20beautiful%20hangwa%20gift%20box%20presentation%2C%20luxurious%20wrapping%20details%2C%20cream%20background%2C%20professional%20product%20photography%2C%20premium%20gift%20presentation&width=800&height=600&seq=feature-packaging-001&orientation=landscape" 
                  alt="정성스런 포장" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 문의 섹션 */}
      <section id="contact" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-white to-amber-50/30">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
            특별한 선물을<br />준비하고 계신가요?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-8 sm:mb-12 leading-relaxed">
            초이담 참새한과가 정성스럽게 준비하겠습니다.<br />
            언제든지 문의해 주세요.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-10 sm:mb-16">
            <Link to="/custom-order" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <button className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-amber-700 text-white rounded-full font-medium hover:bg-amber-800 transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base">
                맞춤 선물 문의하기
              </button>
            </Link>
            <button className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base">
              카카오톡 문의
            </button>
            <button className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white text-gray-900 border-2 border-gray-900 rounded-full font-medium hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base">
              전화 문의
            </button>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 text-left">
            <div className="flex sm:block items-center gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-full flex items-center justify-center sm:mb-4 flex-shrink-0">
                <i className="ri-phone-line text-amber-900 text-lg sm:text-xl"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">전화</h3>
                <p className="text-gray-600 text-sm sm:text-base">02-1234-5678</p>
              </div>
            </div>
            
            <div className="flex sm:block items-center gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-full flex items-center justify-center sm:mb-4 flex-shrink-0">
                <i className="ri-mail-line text-amber-900 text-lg sm:text-xl"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">이메일</h3>
                <p className="text-gray-600 text-sm sm:text-base">info@choidam.com</p>
              </div>
            </div>
            
            <div className="flex sm:block items-center gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-full flex items-center justify-center sm:mb-4 flex-shrink-0">
                <i className="ri-time-line text-amber-900 text-lg sm:text-xl"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">운영 시간</h3>
                <p className="text-gray-600 text-sm sm:text-base">평일 09:00 - 18:00</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 푸터 */}
      <footer className="bg-gradient-to-b from-amber-900 to-amber-950 text-white mx-2 sm:mx-5 mb-2 sm:mb-5 rounded-t-2xl sm:rounded-t-3xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-10 sm:py-16">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
            {/* 첫 번째 컬럼 */}
            <div className="col-span-2 lg:col-span-1">
              <h3 className="text-2xl sm:text-3xl font-bold leading-tight mb-4 sm:mb-6" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                초이담과 함께<br />특별한 선물을
              </h3>
            </div>

            {/* 두 번째 컬럼 - 메뉴 */}
            <div>
              <h4 className="font-medium text-white mb-4 sm:mb-6 text-sm sm:text-base">메뉴</h4>
              <ul className="space-y-2 sm:space-y-4 text-amber-100 text-sm sm:text-base">
                <li><a href="#home" className="hover:text-white transition-colors cursor-pointer">홈</a></li>
                <li><a href="#about" className="hover:text-white transition-colors cursor-pointer">브랜드 소개</a></li>
                <li><a href="#custom-gifts" className="hover:text-white transition-colors cursor-pointer">맞춤 선물</a></li>
                <li><a href="#menu" className="hover:text-white transition-colors cursor-pointer">메뉴</a></li>
                <li><a href="#contact" className="hover:text-white transition-colors cursor-pointer">오시는 길</a></li>
              </ul>
            </div>

            {/* 세 번째 컬럼 - 소셜 미디어 */}
            <div>
              <h4 className="font-medium text-white mb-4 sm:mb-6 text-sm sm:text-base">소셜 미디어</h4>
              <ul className="space-y-2 sm:space-y-4 text-amber-100 text-sm sm:text-base">
                <li className="flex items-center gap-2 sm:gap-3 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-base sm:text-lg"></i>
                  <span>Instagram</span>
                </li>
                <li className="flex items-center gap-2 sm:gap-3 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-article-line text-base sm:text-lg"></i>
                  <span>Blog</span>
                </li>
                <li className="flex items-center gap-2 sm:gap-3 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-chat-3-line text-base sm:text-lg"></i>
                  <span>KakaoTalk</span>
                </li>
              </ul>
            </div>

            {/* 네 번째 컬럼 - 뉴스레터 */}
            <div className="col-span-2 lg:col-span-1">
              <h4 className="font-medium text-white mb-2 sm:mb-3 text-sm sm:text-base">소식 받아보기</h4>
              <p className="text-xs sm:text-sm text-amber-100 mb-3 sm:mb-4">새로운 메뉴와 이벤트 소식을 받아보세요</p>
              <form onSubmit={handleNewsletterSubmit} className="flex items-center bg-amber-800/50 rounded-full overflow-hidden border border-amber-700">
                <input 
                  type="email" 
                  placeholder="이메일 주소" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 bg-transparent px-4 sm:px-5 py-2.5 sm:py-3 text-xs sm:text-sm text-white placeholder-amber-300 outline-none min-w-0"
                />
                <button type="submit" className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-full flex items-center justify-center mr-1 hover:bg-amber-50 transition-colors cursor-pointer flex-shrink-0">
                  <i className="ri-arrow-right-line text-amber-900 text-sm sm:text-base"></i>
                </button>
              </form>
            </div>
          </div>

          {/* 하단 장식 */}
          <div className="relative pt-6 sm:pt-8 border-t border-amber-800">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
              <p className="text-xs sm:text-sm text-amber-200">© 2024 초이담 참새한과. All rights reserved.</p>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-amber-200 hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
